import { addModal, closeCurrentModal } from 'weblite-web-modal-viewer'
import {
  EVENT_CONFIG,
  FORM_CONFIG,
  FORUM_CONFIG,
  MULTIMEDIA_CONFIG,
  NEVISEH_CONFIG,
  POLL_CONFIG,
  POST_CONFIG,
  RAHKAR_CONFIG,
  GENERAL_EXAM_CONFIG,
} from '$common/wapp-bar-theme'
import {
  openEventCreator,
  openFormCreator,
  openForumCreator,
  openGeneralExamCreator,
  openMap,
  openMultimediaCreator,
  openNeviseCreator,
  openPollCreator,
  openPostCreator,
  openRahkarCreator,
} from '$logic/wapps/business'
import { VideoMessageIcon } from '$common/icons/video-message'
import { PhotoMessageIcon } from '$common/icons/photo-message'
import { FileMessageIcon } from '$common/icons/file-message'
import { ContactIcon } from '$common/icons'
import { LocationIcon } from '$common/icons/location'
import { openShareContactList } from '$logic/router'
import { ToolBoxModal } from '.'
import { ToolboxWapp } from './types'
import { CAN_SEND_CONTACT, CAN_SEND_LOCATION } from '$func/environmentInfo'

const wapps: ToolboxWapp[] = [
  {
    ...MULTIMEDIA_CONFIG,
    onClick: openMultimediaCreator,
  },
  {
    ...NEVISEH_CONFIG,
    onClick: openNeviseCreator,
  },
  // {
  //   ...BLOG_CONFIG,
  //   onClick: openBlogCreator,
  // },
  {
    ...POST_CONFIG,
    onClick: openPostCreator,
  },
  {
    ...EVENT_CONFIG,
    onClick: openEventCreator,
  },
  {
    ...FORM_CONFIG,
    onClick: openFormCreator,
  },
  {
    ...POLL_CONFIG,
    onClick: openPollCreator,
  },
  {
    ...FORUM_CONFIG,
    onClick: openForumCreator,
  },
  {
    ...GENERAL_EXAM_CONFIG,
    onClick: openGeneralExamCreator,
  },
]

const mookebWapps = [
  {
    ...NEVISEH_CONFIG,
    onClick: openNeviseCreator,
  },
  {
    ...EVENT_CONFIG,
    onClick: openEventCreator,
  },
  {
    ...FORM_CONFIG,
    onClick: openFormCreator,
  },
  {
    ...POLL_CONFIG,
    onClick: openPollCreator,
  },
  {
    ...FORUM_CONFIG,
    onClick: openForumCreator,
  },
  {
    ...RAHKAR_CONFIG,
    onClick: openRahkarCreator,
  },
]

const COMPONENT_ID = 'toolBoxModal'

const showToolBoxModal = (props: Parameters<typeof ToolBoxModal>[0]) =>
  addModal({ id: COMPONENT_ID, props })

interface ChatToolBoxProps {
  handleUploadMedia: () => unknown
  handleUploadVideo: () => unknown
  handleUploadFile: () => unknown
  roomIsMokeb?: boolean
}

export const showChatToolBoxModal = ({
  handleUploadMedia,
  handleUploadVideo,
  handleUploadFile,
  roomIsMokeb,
}: ChatToolBoxProps) => {
  const messageSelectorActions = [
    {
      icon: (
        <PhotoMessageIcon
          sxProps={{ viewBox: '0 0 24 24', width: '24px', height: '24px' }}
        />
      ),
      name: 'toolBoxModal.actions.image',
      onClick: handleUploadMedia,
    },
    {
      icon: (
        <VideoMessageIcon
          sx={{ viewBox: '0 0 24 24', width: '24px', height: '24px' }}
        />
      ),
      name: 'toolBoxModal.actions.video',
      onClick: handleUploadVideo,
    },
    {
      icon: (
        <FileMessageIcon
          sx={{ viewBox: '0 0 24 24', width: '24px', height: '24px' }}
        />
      ),
      name: 'toolBoxModal.actions.file',
      onClick: handleUploadFile,
    },
    ...(CAN_SEND_LOCATION
      ? [
          {
            icon: <LocationIcon sx={{ color: 'gray' }} />,
            name: 'toolBoxModal.actions.location',
            onClick: openMap,
          },
        ]
      : []),
    ...(CAN_SEND_CONTACT
      ? [
          {
            icon: <ContactIcon sx={{ color: 'gray' }} />,
            name: 'toolBoxModal.actions.contact',
            onClick: openShareContactList,
          },
        ]
      : []),
  ]

  showToolBoxModal({
    wapps: roomIsMokeb ? mookebWapps : wapps,
    messageSelectorActions,
    onClose: closeCurrentModal,
  })
}

export default {
  [COMPONENT_ID]: {
    Component: ToolBoxModal,
  },
}
